/**
 * 历史表里的时间该显示到什么精度。
 *
 * <p>1000 期窗口在 5 分钟档上跨 3 天多，只显示 `18:00` 会让三天前那期看起来像今天
 * 刚开的。原先靠行内日期消歧；2026-09-11 这版改成按天分组、组间插日期分隔行
 * （`groupByLocalDay` + `MilharStatsPage` 的 `dayLabel`），行内时间因此只需要
 * `HH:mm`——`isSameLocalDay` 仍在用，但用途变了：分隔行判断「这一行是不是今天/
 * 昨天」，不再是这里判断「这一行要不要带日期」。
 *
 * <p><b>用设备本地时区，不写死 BRT。</b> `country_registry.timezone` 的用途是业务日
 * 边界，不是给玩家看的时钟 —— 一个在阿根廷的玩家应该看到自己的时间。
 */

/** 两个时刻是否落在**设备本地**的同一天。 */
export function isSameLocalDay(aSec: number, bSec: number): boolean {
  if (!Number.isFinite(aSec) || !Number.isFinite(bSec)) return false;
  const a = new Date(aSec * 1000);
  const b = new Date(bSec * 1000);
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

/**
 * 这一行要显示的时间。
 *
 * <p>`showDate` 字段在按天分组上线后已经没有生产调用方读它了（分隔行接管了
 * 「这一行是哪天」这件事），2026-09-11 评审时一并删掉，不留一个没人读的字段
 * 配一段过时的注释。`nowSec` 参数也随之一起去掉——它只是喂给 `showDate` 计算
 * 用的，`isSameLocalDay` 该由需要分隔行的调用方自己直接调。
 *
 * @returns `null` 表示时间不可用 —— 调用方应当**留空**，而不是显示一个 epoch 0
 *   （1970-01-01）或者当前时间冒充开奖时间
 */
export function historyTimeParts(drawnAtSec: number | null | undefined): { date: Date } | null {
  if (drawnAtSec === null || drawnAtSec === undefined) return null;
  const sec = Number(drawnAtSec);
  // 0 是 1970 —— 后端缺值时给 0 比给 null 更常见，两者都不能当成一个真实时刻。
  if (!Number.isFinite(sec) || sec <= 0) return null;
  return { date: new Date(sec * 1000) };
}
